"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  src: "https://optimal-seahorse.10web.cloud/wp-content/uploads/2026/04/post_top-signs-your-roof-needs-a-professional-inspection.png?v=qsf2tw32vq8",
  alt: "Precision-engineered roofing details showcasing high-durability slate tiles",
  widthClass: "md:w-[30%]"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/mise_rustic_ceiling_beams.png",
  alt: "Modern residential exterior with premium siding and energy-efficient window installation",
  widthClass: "md:w-[40%]"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/mise_candid_laughter.png",
  alt: "Architectural deck construction featuring custom wood grain and structural integrity",
  widthClass: "md:w-[30%]"
}];
export default function TheDiningExperience() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223776" id="project-showcases" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={`transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="text-center mb-16">
            <h2 className="font-default text-4xl md:text-7xl font-bold tracking-tighter mb-4 uppercase">
              Project Showcases
            </h2>
            <p className="font-default text-muted-foreground max-w-2xl mx-auto text-base md:text-lg tracking-normal">
              High-precision exterior solutions engineered for durability and architectural excellence. Explore our recent siding, roofing, and deck transformations.
            </p>
          </div>

          <div className="flex flex-col md:flex-row gap-4 h-auto md:h-[65vh] min-h-[400px]">
            {galleryImages.map((img, i) => <div key={i} data-index={i} className={`relative overflow-hidden w-full h-[350px] md:h-full ${img.widthClass} border border-border/10 rounded-sm shadow-sm`}>
                <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-all duration-700 ease-out grayscale-[0.3] contrast-110 brightness-100 hover:grayscale-0 hover:contrast-100 hover:brightness-105 hover:scale-105" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}